import getT from 'next-translate/getT'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { getCountryAndLocaleStrings } from '../../../utils/locales'
import { getProductSalesCount } from '../../../lib/salesUnit'
import { Product } from '../../../utils/types/Product'
import i18nConfig from '../../../i18n'

const { defaultLocale: defaultCountryAndLocale } = i18nConfig

const useTranslateToDefaultLanguage = (product: Product) => {
  const { asPath, locale: countryAndLocale, replace } = useRouter()

  const { locale } = getCountryAndLocaleStrings(countryAndLocale)
  const { locale: defaultLocale } = getCountryAndLocaleStrings(defaultCountryAndLocale)

  // Translate to default language
  useEffect(() => {
    const translateToDefault = async () => {
      const currentT = await getT(locale, 'products')
      const defaultT = await getT(defaultLocale, 'products')
      const currentPath = getProductSalesCount(product, currentT).replace(/ /g, '-')
      const defaultPath = getProductSalesCount(product, defaultT).replace(/ /g, '-')
      await replace(asPath.replace(currentPath, defaultPath), undefined, { locale: defaultLocale })
    }
    if (!document.cookie.includes('NEXT_LOCALE') && locale !== defaultLocale) {
      // If not default locale,
      // translate url before changing language to default
      translateToDefault()
    }
  }, [asPath])
}

export default useTranslateToDefaultLanguage
